<template>
  <div class="le-info-box">
    <h2 class="le-info-box__heading">
      <slot name="heading" />
    </h2>
    <p class="le-info-box__text">
      <slot name="text" />
    </p>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";
@import "@fontsource/montserrat/700.css";

.le-info-box {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  border-radius: 8px;
  background: #2561b3;
  color: white;

  #media-breakpoint-up(lg, {
    gap: 16px;
  });

  &__heading,
  &__text {
    margin: 0;
  }

  &__heading {
    font-family: Montserrat, sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 22px;
  }

  &__text {
    line-height: 24px;
  }
}
</style>
